/** Traductions page gestion paiements / export factures ouvertes (FR / AR) */
export const paymentManagementPageFr = {
  exportColInvoiceNumber: 'Numéro de Facture',
  exportColSupplier: 'Fournisseur',
  exportColTotalAmount: 'Montant Total',
  exportColPaidAmount: 'Montant Payé',
  exportColRemainingAmount: 'Montant Restant',
  exportColStatus: 'Statut',
  summaryTotalInvoices: 'Total Factures',
  summaryTotalAmount: 'Montant Total',
  summaryRemainingAmount: 'Montant Restant',
  hideItems: 'Masquer les articles',
  showItems: 'Afficher les articles',
  consolidated: 'Consolidé',
  invoiceItemsTitle: 'Articles de la facture',
  colProduct: 'Produit',
  colQty: 'Qté',
  colUnitPrice: 'PU',
  colTotal: 'Total',
  itemFallback: 'Article',
  noItems: 'Aucun article'
};

export const paymentManagementPageAr = {
  exportColInvoiceNumber: 'رقم الفاتورة',
  exportColSupplier: 'المورد',
  exportColTotalAmount: 'المبلغ الإجمالي',
  exportColPaidAmount: 'المبلغ المدفوع',
  exportColRemainingAmount: 'المبلغ المتبقي',
  exportColStatus: 'الحالة',
  summaryTotalInvoices: 'إجمالي الفواتير',
  summaryTotalAmount: 'المبلغ الإجمالي',
  summaryRemainingAmount: 'المبلغ المتبقي',
  hideItems: 'إخفاء العناصر',
  showItems: 'عرض العناصر',
  consolidated: 'مدمج',
  invoiceItemsTitle: 'عناصر الفاتورة',
  colProduct: 'المنتج',
  colQty: 'الكمية',
  colUnitPrice: 'سعر الوحدة',
  colTotal: 'المجموع',
  itemFallback: 'عنصر',
  noItems: 'لا توجد عناصر'
};
